import createApp from "./main"
import setupPermission from "./permission";
import store from "./store";

const { app, router } = createApp()

// 初始化路由守卫
setupPermission(router);

if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__)
}

// 添加最近浏览文章列表到 localStorage 的监听
window.addEventListener('beforeunload', () => {
    const recentList = store.state.article.recentArticleList
    localStorage.setItem('recentArticleList', JSON.stringify(recentList))
});

router.onReady(() => {
    //挂载激活app
    app.$mount("#app")
})